import React from 'react';
import { motion } from 'framer-motion';
import { motionPresets } from '../../lib/motion';

const Card = ({ 
  children, 
  className = '', 
  variant = 'default',
  animate = true,
  hover = true,
  ...props 
}) => {
  const variants = {
    default: 'backdrop-blur-lg border border-[#d9cbb4]/50 shadow-glass bg-[#fdf6eb]/95 text-gray-900',
    strong: 'backdrop-blur-xl border border-[#d0c0a4]/60 shadow-glass-lg bg-[#f7ecd9]/95 text-gray-900',
    subtle: 'backdrop-blur-md border border-[#e3d4bd]/40 shadow-glass bg-[#fdf7ef]/90 text-gray-900',
    dark: 'backdrop-blur-lg border border-[#cabaa1]/40 shadow-glass-xl bg-black/10 dark:bg-black/25 text-white'
  };

  const Component = animate ? motion.div : 'div';

  const motionProps = animate ? {
    ...motionPresets.fadeUp,
    ...(hover && motionPresets.hoverLift)
  } : {};

  return (
    <Component
      className={`
        rounded-glass p-6 
        ${variants[variant]}
        ${hover ? 'hover-lift transition-all duration-120' : ''}
        ${className}
      `}
      {...motionProps}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;
